const comments = [
  {
    name: '影迷小张',
    time: '2小时前',
    avatar: '影',
    content: '嫩草视频真的方便，手机浏览器打开就能看，97视频和丝瓜视频的资源都有，高清还不卡，比下载APP省心多了！',
    tag: '忠实用户',
  },
  {
    name: '追剧达人',
    time: '5小时前',
    avatar: '追',
    content: '一直在找能看蓝莓视频和91在线视频的网页版，嫩草视频完美解决了我的需求，电影电视剧更新也快，推荐给身边朋友了。',
    tag: '新用户',
  },
  {
    name: '电影发烧友',
    time: '昨天',
    avatar: '电',
    content: '资源丰富且高清不卡顿，这个网页版体验比很多APP都好。动画和纪录片区也有很多有意思的内容，会一直用下去。',
    tag: '活跃用户',
  },
  {
    name: '随便看看',
    time: '昨天',
    avatar: '随',
    content: '偶尔打开看看综艺和喜剧解压，碎片时间刷刷挺合适。高清流畅是真的，手机网页版能做到这样很不容易。',
    tag: '日常用户',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900">
            用户评价
          </h2>
          <p className="mt-2 text-sm text-foreground-500 font-label">听听大家怎么说嫩草视频</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {comments.map((item) => (
            <div
              key={item.name}
              className="p-5 rounded-xl bg-background-100 border border-background-200/60 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center font-heading font-bold text-primary-700 text-sm flex-shrink-0">
                  {item.avatar}
                </div>
                <div className="min-w-0">
                  <div className="font-heading font-semibold text-sm text-foreground-800 whitespace-nowrap">{item.name}</div>
                  <div className="text-xs text-foreground-400 font-label">{item.time}</div>
                </div>
                <span className="ml-auto px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-label flex-shrink-0 whitespace-nowrap">{item.tag}</span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed font-label flex-1">
                "{item.content}"
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}